"use client";

import Title from "antd/lib/typography/Title";
import Paragraph from "antd/lib/typography/Paragraph";
import React from "react";
import {
  EnvironmentOutlined,
  FilterOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { STYLIST_SERVICES } from "@/lib/stylists";
import styles from "../components/stylists.module.scss";

// Keep this boundary in the directory route group so profile navigation cannot
// show the team skeleton while the /stylists/[id] layout resolves.
export default function LoadingStylists() {
  return (
    <main
      className={styles.browser}
      data-view="map"
      aria-busy="true"
      aria-label="Loading stylists"
    >
      <header className={styles.header}>
        <div>
          <Title level={1} className="page-title page-title--visual-h4">
            Team Edition
          </Title>
          <Paragraph className={styles.subtitle}>
            Find your stylist. Explore their work.
          </Paragraph>
        </div>
        <div className={styles.viewSwitch} aria-hidden="true">
          <button type="button" disabled aria-pressed="false">
            <UnorderedListOutlined /> List
          </button>
          <button type="button" disabled aria-pressed="true">
            <EnvironmentOutlined /> Map
          </button>
        </div>
      </header>

      <div className={styles.toolbar} aria-hidden="true">
        <div className={styles.filterRow}>
          <div className={styles.filterChips}>
            <button type="button" disabled aria-pressed="true">
              All services
            </button>
            {STYLIST_SERVICES.map((service) => (
              <button type="button" disabled key={service.id}>
                {service.label}
              </button>
            ))}
          </div>
          <button type="button" disabled className={styles.filterButton}>
            <FilterOutlined /> Filters
          </button>
        </div>
      </div>

      <div className={`${styles.directoryLayout} ${styles.mapLayout}`}>
        <aside className={styles.mapPane} aria-hidden="true">
          <div className={styles.loadingMap}>
            <EnvironmentOutlined />
          </div>
        </aside>
        <section className={styles.results}>
          <div className={styles.resultsHeading}>
            <p role="status">Loading stylists…</p>
          </div>
          <div className={styles.grid} aria-hidden="true">
            {Array.from({ length: 6 }, (_, index) => (
              <div key={index} className={`${styles.card} ${styles.loadingCard}`}>
                <div className={styles.cardIdentity}>
                  <div className={styles.nameRow}>
                    <span className={`${styles.avatar} ${styles.loadingShape}`} />
                    <span className={`${styles.loadingName} ${styles.loadingShape}`} />
                  </div>
                  <div className={styles.cardLocations}>
                    <span className={`${styles.loadingLocation} ${styles.loadingShape}`} />
                  </div>
                </div>
                <div className={styles.photos}>
                  {Array.from({ length: 3 }, (_, photo) => (
                    <div
                      key={photo}
                      className={`${styles.workPhoto} ${styles.loadingShape}`}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </main>
  );
}
